(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function () {
  function initCountdownTimer(timer) {
    var existingInterval = parseInt(timer.dataset.ctInterval);
    if (existingInterval) clearInterval(existingInterval);

    var endDay = parseInt(timer.dataset.endDay);
    var endMonth = parseInt(timer.dataset.endMonth);
    var endYear = parseInt(timer.dataset.endYear);
    var endHour = parseInt(timer.dataset.endHour || '0');
    var endMinute = parseInt(timer.dataset.endMinute || '0');

    if (!endDay || !endMonth || !endYear) {
      timer.setAttribute('hidden', '');
      return;
    }

    var end = new Date(endYear, endMonth - 1, endDay, endHour, endMinute, 0);

    var startDay = parseInt(timer.dataset.startDay);
    var startMonth = parseInt(timer.dataset.startMonth);
    var startYear = parseInt(timer.dataset.startYear);
    var startHour = parseInt(timer.dataset.startHour || '0');
    var startMinute = parseInt(timer.dataset.startMinute || '0');

    var start = (startDay && startMonth && startYear)
      ? new Date(startYear, startMonth - 1, startDay, startHour, startMinute, 0)
      : null;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = new Date();
      if (start && now < start) {
        timer.setAttribute('hidden', '');
        return;
      }
      var diff = end - now;
      if (diff <= 0) {
        timer.setAttribute('hidden', '');
        clearInterval(parseInt(timer.dataset.ctInterval));
        return;
      }
      timer.removeAttribute('hidden');
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);
      var daysEl = timer.querySelector('[data-ct-days]');
      var hoursEl = timer.querySelector('[data-ct-hours]');
      var minsEl = timer.querySelector('[data-ct-minutes]');
      var secsEl = timer.querySelector('[data-ct-seconds]');
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(minutes);
      if (secsEl) secsEl.textContent = pad(seconds);
    }

    tick();
    var intervalId = setInterval(tick, 1000);
    timer.dataset.ctInterval = intervalId;
  }

  function initAllInContext(root) {
    root.querySelectorAll('.countdown-timer').forEach(initCountdownTimer);
  }

  initAllInContext(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAllInContext(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["timer-collection"] && !Shopify.designMode) return;
  try {
    (function () {

  var countdownIsActive = false;



  /*
   * COLLECTION
   *
   * On cible directement la structure native
   * de ta section Collection Horizon :
   *
   * <div class="section-background">
   * <results-list class="... product-grid-container">
   */
  function getCollectionElements() {

    var resultsLists =
      document.querySelectorAll(
        'results-list.product-grid-container'
      );


    var elements = [];


    resultsLists.forEach(
      function (resultsList) {

        elements.push(
          {
            element: resultsList,
            type: 'results'
          }
        );


        var previous =
          resultsList.previousElementSibling;


        if (
          previous &&
          previous.classList.contains(
            'section-background'
          )
        ) {

          elements.push(
            {
              element: previous,
              type: 'background'
            }
          );

        }

      }
    );


    return elements;

  }



  function updateCollectionVisibility() {

    var collectionElements =
      getCollectionElements();


    collectionElements.forEach(
      function (item) {

        if (
          item.type ===
          'results'
        ) {

          if (countdownIsActive) {

            item.element.setAttribute(
              'hidden',
              ''
            );

          } else {

            item.element.removeAttribute(
              'hidden'
            );

          }

        }


        if (
          item.type ===
          'background'
        ) {

          if (countdownIsActive) {

            item.element.setAttribute(
              'data-countdown-hidden',
              ''
            );

          } else {

            item.element.removeAttribute(
              'data-countdown-hidden'
            );

          }

        }

      }
    );

  }



  /*
   * KLAVIYO
   */
  function getKlaviyoForms() {

    return document.querySelectorAll(
      '[class*="klaviyo-form-"]'
    );

  }



  function getKlaviyoContainer(form) {

    /*
     * On essaye de masquer le bloc Shopify complet
     * mais pas une section entière susceptible
     * de contenir également le timer.
     */
    var container =
      form.closest(
        '.shopify-app-block, .shopify-block, [id^="shopify-block-"]'
      );


    if (container) {
      return container;
    }


    /*
     * Fallback :
     * le formulaire lui-même.
     */
    return form;

  }



  function updateKlaviyoVisibility() {

    var klaviyoForms =
      getKlaviyoForms();


    klaviyoForms.forEach(
      function (form) {

        var container =
          getKlaviyoContainer(
            form
          );


        container.setAttribute(
          'data-countdown-klaviyo-wrapper',
          ''
        );


        if (countdownIsActive) {

          container.removeAttribute(
            'hidden'
          );

        } else {

          container.setAttribute(
            'hidden',
            ''
          );

        }

      }
    );

  }



  function setCountdownState(isActive) {

    countdownIsActive =
      isActive;


    updateCollectionVisibility();

    updateKlaviyoVisibility();

  }



  function initCountdownTimer(timer) {

    var existingInterval =
      parseInt(
        timer.dataset.ctInterval,
        10
      );


    if (existingInterval) {

      clearInterval(
        existingInterval
      );

    }


    var endValue =
      timer.dataset.end;


    /*
     * Pas de date.
     */
    if (!endValue) {

      timer.setAttribute(
        'hidden',
        ''
      );


      setCountdownState(
        false
      );


      return;
    }


    var end =
      new Date(
        endValue
      );


    /*
     * Date invalide.
     */
    if (
      Number.isNaN(
        end.getTime()
      )
    ) {

      timer.setAttribute(
        'hidden',
        ''
      );


      setCountdownState(
        false
      );


      return;
    }



    function pad(number) {

      return String(number)
        .padStart(
          2,
          '0'
        );

    }



    function tick() {

      var now =
        Date.now();


      var diff =
        end.getTime() -
        now;


      /*
       * DATE TERMINÉE
       *
       * Timer      caché
       * Klaviyo    caché
       * Collection visible
       */
      if (diff <= 0) {

        timer.setAttribute(
          'hidden',
          ''
        );


        setCountdownState(
          false
        );


        var intervalId =
          parseInt(
            timer.dataset.ctInterval,
            10
          );


        if (intervalId) {

          clearInterval(
            intervalId
          );

        }


        return;
      }


      /*
       * TIMER ACTIF
       *
       * Timer      visible
       * Klaviyo    visible
       * Collection cachée
       */
      timer.removeAttribute(
        'hidden'
      );


      setCountdownState(
        true
      );


      var days =
        Math.floor(
          diff /
          86400000
        );


      var hours =
        Math.floor(
          (
            diff %
            86400000
          ) /
          3600000
        );


      var minutes =
        Math.floor(
          (
            diff %
            3600000
          ) /
          60000
        );


      var seconds =
        Math.floor(
          (
            diff %
            60000
          ) /
          1000
        );


      var daysEl =
        timer.querySelector(
          '[data-ct-days]'
        );


      var hoursEl =
        timer.querySelector(
          '[data-ct-hours]'
        );


      var minutesEl =
        timer.querySelector(
          '[data-ct-minutes]'
        );


      var secondsEl =
        timer.querySelector(
          '[data-ct-seconds]'
        );


      if (daysEl) {

        daysEl.textContent =
          pad(days);

      }


      if (hoursEl) {

        hoursEl.textContent =
          pad(hours);

      }


      if (minutesEl) {

        minutesEl.textContent =
          pad(minutes);

      }


      if (secondsEl) {

        secondsEl.textContent =
          pad(seconds);

      }

    }



    /*
     * Vérification immédiate.
     */
    tick();



    /*
     * Rafraîchissement chaque seconde
     * uniquement si le timer est actif.
     */
    if (
      !timer.hasAttribute(
        'hidden'
      )
    ) {

      var intervalId =
        setInterval(
          tick,
          1000
        );


      timer.dataset.ctInterval =
        String(
          intervalId
        );

    }

  }



  function initAllCountdownTimers(root) {

    root
      .querySelectorAll(
        '[data-collection-countdown]'
      )
      .forEach(
        initCountdownTimer
      );

  }



  /*
   * Chargement normal.
   */
  initAllCountdownTimers(
    document
  );



  /*
   * Klaviyo peut être injecté
   * après le chargement initial.
   */
  var observerScheduled =
    false;


  var klaviyoObserver =
    new MutationObserver(
      function () {

        if (observerScheduled) {
          return;
        }


        observerScheduled =
          true;


        requestAnimationFrame(
          function () {

            observerScheduled =
              false;


            updateKlaviyoVisibility();

          }
        );

      }
    );


  klaviyoObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );



  /*
   * Éditeur Shopify.
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAllCountdownTimers(
        event.target
      );


      updateCollectionVisibility();

      updateKlaviyoVisibility();

    }
  );

})();
  } catch(e) { console.error(e); }
})();

})();
